class CashMovementEventReasonController extends AbstractEntityEditController
	@register()
	@inject 'reason',
		'CashMovementEventReasonRepository'

	initialize: ->
		@mainCrud.entityType = 'general.cash_movement_event_reason'
		@mainCrud.entityTitle = 'general.cash_movement_event_reason.new'

		if @reason.id?
			@mainCrud.entityTitle = @reason.reason
			@mainCrud.isNewEntity = false

	save: ->
		@CashMovementEventReasonRepository
			.save(@reason, @mainCrud.isNewEntity)
			.then (response) =>
				@afterSave(response, @mainCrud.entityType, @mainCrud.isNewEntity, 'reason')
			.catch (response) =>
				@handleErrors(response)

	delete: ->
		@deleteEntity(@CashMovementEventReasonRepository, @reason)
